import axios from "axios";
import { toast } from "react-toastify";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { URI } from "../../configs";
import { useSelector } from "react-redux";

export const getLines = createAsyncThunk(
    "equipment/Line",
    async (token) => { // <-- destructure getState method

        const apiUrl = URI + "api/v1/lines/"

        //const apiUrl = "https://test.digitsolution.space/api/v1/token/login/";
        var config = {
            method: "get",
            url: apiUrl,
            headers: {
                accept: "application/json",
                Authorization: `Token ${token}`
            },
        };
        console.log(config)
        const response = await axios(config);
        const data = await response.data;
        return data;
    }
);


export const getAreas = createAsyncThunk(
    "equipment/Area",
    async (arg) => { // <-- destructure getState method


        let line = arg.line
        let token = arg.token
        const apiUrl = URI + "api/v1/areas/" + `?line__name=${line}`
        console.log('AREA REQUEST')
        console.log(token)
        //const apiUrl = "https://test.digitsolution.space/api/v1/token/login/";
        var config = {
            method: "get",
            url: apiUrl,
            headers: {
                accept: "application/json",
                Authorization: `Token ${token}`
            },
        };

        const response = await axios(config);
        const data = await response.data;
        return data;
    }
);


export const getMachines = createAsyncThunk(
    "equipment/Machine",
    async (arg) => { // <-- destructure getState method
        console.log(arg)
        let area = arg.area
        let token = arg.token
        const apiUrl = URI + "api/v1/equipments/" + `?area__name=${area}`
        //const apiUrl = "https://test.digitsolution.space/api/v1/token/login/";
        var config = {
            method: "get",
            url: apiUrl,
            headers: {
                accept: "application/json",
                Authorization: `Token ${token}`
            },
        };

        const response = await axios(config);
        const data = await response.data;
        return data;
    }
);


export const getMachinesByLineArea = createAsyncThunk(
    "equipment/MachineByLineArea",
    async (arg) => { // <-- destructure getState method
        console.log(arg)
        console.log('znacheniya!')
        let machine = arg.machine
        let line = arg.line
        let area = arg.area
        let token = arg.token
        console.log('MACHINE REQUEST')
        console.log(token)
        const apiUrl = URI + "api/v1/equipments/" + `?area__name=${area}&` + `area__line__name=${line}&` + `name=${machine}`
        //const apiUrl = "https://test.digitsolution.space/api/v1/token/login/";
        var config = {
            method: "get",
            url: apiUrl,
            headers: {
                accept: "application/json",
                Authorization: `Token ${token}`
            },
        };

        const response = await axios(config);
        const data = await response.data;
        return data;
    }
);
